export default class TerritoryRenderer {
  constructor(ctx) {
    this.ctx = ctx
  }

  drawFields({ territories, camera, state, atmosphere, viewport }) {
    this.ctx.save()

    territories.forEach(territory => {
      const center = camera.worldToScreen(territory.center.x, territory.center.y)
      const radius = Math.max(territory.radius * camera.zoom, 56)
      const isSelected = territory.id === state.selectedClusterId

      if (!this.isVisible(center, radius, viewport)) {
        return
      }

      const outer = this.ctx.createRadialGradient(
        center.x,
        center.y,
        radius * 0.1,
        center.x,
        center.y,
        radius
      )

      outer.addColorStop(0, this.toRgba(territory.color, isSelected ? 0.14 : 0.05 + territory.density * 0.04))
      outer.addColorStop(0.56, this.toRgba(territory.color, 0.025 + territory.density * 0.02 + atmosphere.glow * 0.015))
      outer.addColorStop(1, this.toRgba(territory.color, 0))

      this.ctx.fillStyle = outer
      this.ctx.beginPath()
      this.ctx.arc(center.x, center.y, radius, 0, Math.PI * 2)
      this.ctx.fill()

      if (isSelected) {
        this.ctx.beginPath()
        this.ctx.arc(center.x, center.y, radius * 0.64, 0, Math.PI * 2)
        this.ctx.lineWidth = 1
        this.ctx.strokeStyle = this.toRgba(territory.color, 0.18)
        this.ctx.stroke()
      }
    })

    this.ctx.restore()
  }

  drawLabels({ territories, camera, state, viewport, time }) {
    this.ctx.save()
    this.ctx.textAlign = 'center'

    territories.forEach(territory => {
      const center = camera.worldToScreen(territory.center.x, territory.center.y)
      const radius = Math.max(territory.radius * camera.zoom, 56)
      const isSelected = territory.id === state.selectedClusterId

      if (!this.isVisible(center, radius, viewport)) {
        return
      }

      const pulse = 0.88 + Math.sin(time * 0.2 + territory.members.length) * 0.05
      const alpha = isSelected
        ? 0.9
        : Math.min(0.26, 0.08 + Math.max(0, camera.zoom - 0.85) * 0.08 + territory.density * 0.04) * pulse

      this.ctx.font = `${isSelected ? 15 : 12}px system-ui, sans-serif`
      this.ctx.fillStyle = this.toRgba('#eef2ff', alpha)
      this.ctx.fillText(territory.title, center.x, center.y)

      if (isSelected) {
        this.ctx.font = '10px system-ui, sans-serif'
        this.ctx.fillStyle = this.toRgba('#c7d2fe', 0.7)
        this.ctx.fillText(territory.dominantMood, center.x, center.y + 14)
      }
    })

    this.ctx.restore()
  }

  isVisible(center, radius, viewport) {
    return center.x + radius > 0
      && center.x - radius < viewport.width
      && center.y + radius > 0
      && center.y - radius < viewport.height
  }

  toRgba(color, alpha) {
    if (color.startsWith('rgb(')) {
      return color.replace('rgb(', 'rgba(').replace(')', `, ${alpha})`)
    }

    const normalized = color.replace('#', '')
    const value = normalized.length === 3
      ? normalized.split('').map(char => char + char).join('')
      : normalized
    const int = Number.parseInt(value, 16)

    return `rgba(${(int >> 16) & 255}, ${(int >> 8) & 255}, ${int & 255}, ${alpha})`
  }
}
